import React, { useRef, useState } from "react";
import Checkbox from "./Checkbox";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";

interface Props extends RowItem, Omit<InterfaceComponentsProps,"icon"> { 
    required: boolean;
    placeholder: string;
    onChange: (arg:string) => any;
    onBlur?: () => any;
    checkboxModel: boolean;
    checkboxChanged: (...args:any) => any
    tableClass:string
    model: any
}

function DatePicker(props:Partial<Props>) {
    const datePickerRef = useRef<HTMLInputElement>(null);
    const hasCheckBox = props.checkboxChanged;
    //https://reactdatepicker.com/#example-custom-date-format
    // اذا بدنا نثبت الفورمات
    function getDateString(date:string) {
        try {
            let returnDate = new Date(date)
            let year :string | number= returnDate.getFullYear();
            year = year < 10 ? "000" + year :
                year < 100 ? "00" + year :
                    year < 1000 ? "0" + year : year;
            if (isNaN(returnDate.getMonth()) || isNaN(returnDate.getDate()))
                throw new Error("not valid number");
            return (
                year + "-" +
                (returnDate.getMonth() < 9 ? "0" : "") +
                (returnDate.getMonth() + 1) +
                "-" +
                (returnDate.getDate() < 10 ? "0" : "") +
                returnDate.getDate()
            );
        } catch (e) {
            console.log("DateError",e)
            console.log("date", date)
            return date;
        }
    }

    function handler(event:any) {
        const { value } = event.target;
            props?.onChange?.(value);
    }
    function blurhandler(event:any) {
        const { value } = event.target;
        if (value === '')
            props?.onChange?.(app.today());
        else
            props?.onBlur?.();
            

    }
    var datePicker = <input
        id={props.id ? props.id : "date" + props.label}
        ref={datePickerRef}
        type="date"
        role="button"
        value={getDateString(props.model)}
        className={`form-control form-control-sm min-height-29 ${props.checkboxModel ? "height-20 " : " "} ${hasCheckBox ? "" : "rounded-e"}   shadow-none ${props.required && !props.model ? " is-invalid  border-1" :
            props.isTable ? " border-1 text-center bg-body-tertiary " + props.tableClass : ("border-0 " + props.class)}`}
        disabled={props.disabled || props.checkboxModel === false}
        onChange={handler}
        onBlur={blurhandler}
        placeholder={app.translate(props.placeholder)}
        max="3000-12-31"
        required={props.required}
    />;
    var pikerButton = <button className={`btn btn-sm ${props.checkboxModel ? "min-height-29" : "height-29"} border-0 pt-1 px-2 btn-primary`} type="button" onClick={openPicker} disabled={props.disabled || props.checkboxModel === false}>
        <i className={` iconssc-calender`} />
    </button>

    function openPicker() {
        datePickerRef.current?.showPicker()
    }
    return (
        props.isTable ?
            <div className="input-group focus-group min-height-29">
                {datePicker}
                {pikerButton }
            </div>
            :

            <div>
                <label className={` ms-1 ${(props.labelClass ||"fw-semibold text-primary-emphasis")}`}>{app.translate(props.label)}</label> 
                <div className="input-group border rounded focus-group height-31" >
                           {props.checkboxChanged && <Checkbox id="IsFrom" class="d-flex align-items-center justify-cntent-center mx-2" className="text-center"
                               model={props.checkboxModel!} onChange={props.checkboxChanged} />}
                    {datePicker}
                    {pikerButton }       
        </div>
    </div>
    );
}

DatePicker.defaultProps = {
    label: "Date",
    model: new Date(),
    placeholder: "",
    class: " ",
    disabled: false,
    required: false,
    isTable: false
}

export default DatePicker;